export const BIG_BAR_FONT =
    "Montserrat, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";

export const BIG_TEXT_MUTED =
    'text-[oklch(0.553_0.013_58.071)] dark:text-[oklch(0.709_0.01_56.259)]';

export const BIG_TEXT_FOREGROUND =
    'text-[oklch(0.147_0.004_49.25)] dark:text-[oklch(0.985_0.001_106.423)]';

export const BIG_ICON_BUTTON =
    'flex justify-center items-center rounded-md w-8 h-8 text-neutral-600 hover:text-black dark:text-neutral-400 dark:hover:text-white hover:bg-[oklch(0.97_0.001_106.424)] dark:hover:bg-[oklch(0.268_0.007_34.298)] transition-colors cursor-pointer disabled:cursor-not-allowed disabled:opacity-50';
